import {environmentSchema} from './environment.schema';

// Environment variables are validated at build time by the Vite env-validator plugin.
// This parse will always succeed if the build passed.
export const environment = environmentSchema.parse(import.meta.env);
